/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
const awsmobile = {
  aws_project_region: "ap-northeast-2",

  Auth: {
    region: "ap-northeast-2",
    userPoolId: "ap-northeast-2_1FgM5Qp9A", // Please change this value.
    userPoolWebClientId: "3q07cpbc9rhpl1i6tgdbchqvto", // Please change this value.
    identityPoolId: "ap-northeast-2:d3e17199-21d8-4b85-b537-95921df0c389",
  },
  aws_cloud_logic_custom: [
    {
      name: "MainApi",
      endpoint: "https://prrb507od3.execute-api.ap-northeast-2.amazonaws.com/Poc/",
      region: "ap-northeast-2",
    },
    {
      name: "UnAuth",
      endpoint: "https://prrb507od3.execute-api.ap-northeast-2.amazonaws.com/Poc/",
      region: "ap-northeast-2",
    },
  ],
};

export default awsmobile;
